import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroVariant83 } from '../components/HeroVariant83';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { Stats } from '../components/Stats';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage83() {
  return <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] transition-colors duration-300" data-id="element-1862">
      <Navigation data-id="element-1863" />
      <main data-id="element-1864">
        <HeroVariant83 data-id="element-1865" />
        <About data-id="element-1866" />
        <Services data-id="element-1867" />
        <WhyUs data-id="element-1868" />
        <Stats data-id="element-1869" />
        <Testimonials data-id="element-1870" />
        <FAQ data-id="element-1871" />
        <Consultation data-id="element-1872" />
      </main>
      <Footer data-id="element-1873" />
      <CookieBanner data-id="element-1874" />
      <FloatingContact data-id="element-1875" />
    </div>;
}